export interface FilePayload {
  name: string;
  type: string;
  base64: string;
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export async function fileToBase64Payload(file: File): Promise<FilePayload> {
  const arrayBuffer = await file.arrayBuffer();
  return {
    name: file.name,
    type: file.type,
    base64: arrayBufferToBase64(arrayBuffer),
  };
}

export async function filesToBase64Payloads(
  files: File[],
): Promise<FilePayload[]> {
  return Promise.all(files.map(fileToBase64Payload));
}

export function filePayloadToBuffer(payload: FilePayload): {
  name: string;
  type: string;
  data: Buffer;
} {
  return {
    name: payload.name,
    type: payload.type,
    data: Buffer.from(payload.base64, "base64"),
  };
}

export function downloadBase64File(payload: {
  base64: string;
  fileName: string;
  fileType: string;
}): void {
  const byteChars = atob(payload.base64);
  const byteArray = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteArray[i] = byteChars.charCodeAt(i);
  }
  const blob = new Blob([byteArray], { type: payload.fileType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = payload.fileName;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
